<template>
	<ul class="list">
		<li v-for="item in list" @click="toDetail(item)">
			<div class="list-title">
				<h3>{{item.title}}</h3>
			</div>
			<div class="list-desc">
				{{item.introduction}}
			</div>
		</li>
	</ul>
</template>

<script>
	export default {
		name: 'SearchDown',
		props: {
			list: {
				type: Array,
				value: []
			}
		},
		methods: {
			toDetail(item){
				console.log(item)
				window.location.href = item.picUrl
			}
		}
	}
</script>

<style scoped lang="less">
	.list{
		padding: 10px;
		li{
			border-bottom: 1px solid #e7e8eb;
			padding: 13px 24px;
			.list-title{
				position: relative;
				display: flex;
				align-items: center;
				margin-bottom: 9px;
				
				text-overflow: ellipsis;
				white-space: nowrap;
				word-break: break-all;
				word-wrap: break-word;
				h3{
					flex: 1;
					overflow: hidden;
					font-size: 18px;
					line-height: 26px
				}
			}
			.list-desc{
				margin-bottom: 12px;
				color: #404040;
				text-align: justify;
				line-height: 18px;
				font-size: 12px;
			}
		}
		li:hover{
			position: relative;
			background-color:#f3f9ff;
			z-index: 1
		}
	}
</style>
